var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-title',{attrs:{"size":"body-1","space":"4","title":"BLEACHED SOLUTIONS","weight":"regular"}}),_c('base-body',[_vm._v(" Custom software to accelerate your business needs ")]),_c('base-btn',{staticClass:"mb-12",attrs:{"outlined":""}},[_vm._v(" More Info ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }